import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  ModelDeleteEvent,
  OrderDataModelUpdateSource,
  ITraderGroupLookupService,
  IUserLookupService,
} from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

/** Reason constant used when visibility of an order is lost  */
export const TRANSFERED_OUT_OF_VISIBILITY = "out.visibility.transfer";

/**
 * Interface for addtional xfer data added to internal xfer-related events
 */
export interface AdditionalTransferData {
  source: OrderDataModelUpdateSource;
  xferId: string;
  xferEventType: CubiqTS.XferType;
  xferComment: string;
  xferUserName: string;
  xferTargetGroupId: CubiqTS.Long;
  xferTargetGroup: string;
}

/**
 * Set of Transfer Util functions that for ensure common mechanisms for create Ids and transfer data.
 *
 * Defined outside a service so there are no circular depenencies and can be used anywhere
 */
export class TransferUtils {
  constructor() {}

  /**
   * Get the ID used to identify a single risk transfer item - where a ModelDeleteEvent is the source, the
   * function gives preference to any xferId  property defined on the event.
   *
   * @param order
   * @param isBenchmark
   * @returns
   */
  public static getTransferId(
    order: CubiqTS.OrderDataImpl | ModelDeleteEvent,
    isBenchmark: boolean,
  ): string {
    if (order instanceof ModelDeleteEvent) {
      return order.xferId ?? order.id;
    }

    if (order?.orderId) {
      // If there's no order Id there should be no allocation Ids either
      return isBenchmark && order?.allocationData?.[0]?.riskId
        ? order.allocationData[0].riskId.toString()
        : order.orderId.toString();
    }
    logger.out.warn(`Cannot create transfer ID for order`);
    return "";
  }

  /**
   * Get information required to be added to any ModelDeleteEvent sent out from BM or limit Order PrimaryLookupService
   * @param event the transfer event
   */
  public static getXferEventAdditionalData(
    event: CubiqTS.XferEventImpl,
    userLookupService: IUserLookupService,
    traderGroupService: ITraderGroupLookupService,
  ): AdditionalTransferData {
    let username: string = null;
    if (event.actioningUserId != null && userLookupService) {
      let user: CubiqTS.UserImpl = userLookupService.getUserById(event.actioningUserId.toString());
      username = user != null ? user.userName : username;
    }

    let targetGroup: string = null;
    if (event.targetGroupId != null && traderGroupService) {
      let tradeGroup: CubiqTS.TradingGroupImpl = traderGroupService.getItem(
        event.targetGroupId.toString(),
      );
      targetGroup = tradeGroup != null ? tradeGroup.groupCode : targetGroup;
    }

    return {
      source: OrderDataModelUpdateSource.XferEvent,
      xferId: null,
      xferEventType: event.eventType,
      xferComment: event.comment,
      xferUserName: username,
      xferTargetGroupId: event.targetGroupId,
      xferTargetGroup: targetGroup,
    };
  }
}
